import {
	ExplorerCard,
	IDashboardConfig,
	IExplorerView,
	ISavedDashboard,
	SavedViewTypes,
	SavedWidget,
} from 'hooks/savedViews/types';
import { LAYOUT_OPTIONS } from '/views/explorer/layoutOptions';

export function transformExplorerViewToDashboard(explorer: IExplorerView, name: string): ISavedDashboard;
export function transformExplorerViewToDashboard(explorer: IExplorerView, name: undefined): IDashboardConfig;
export function transformExplorerViewToDashboard(explorer, name) {
	const selectedDefinition = explorer.selectedDefinitionName;
	const filters = explorer.filters;
	const cardConfigs = explorer.layout.cards.map((card) =>
		transformExplorerCardToDashboard(card, selectedDefinition, filters)
	);

	let meta;
	if (name) {
		meta = {
			metaData: {
				type: SavedViewTypes.Dashboard,
				name,
				isFavorite: false
			},
		};
	}

	return {
		cards: cardConfigs,
		...meta,
	};
}

export function transformExplorerCardToDashboard(
	card: ExplorerCard,
	selectedDefinition,
	filters: { facets: {activeFacets, activeHierarchicalFacets}; timeline },
	name = ''
): SavedWidget {
	return {
		type: card.type,
		dataConfiguration: {
			selectedDefinition: selectedDefinition,
			filters: {
				activeFacets: filters.facets?.activeFacets || {},
				activeHierarchicalFacets: filters.facets?.activeHierarchicalFacets || {},
				timeline: filters.timeline,
			},
			endpointQuery: {
				endpointKey: card.type,
				selectedDefinition,
				options: card.endpointQuery.options,
				parameters: card.endpointQuery.parameters,
			},
		},
		widgetConfiguration: card.widgetConfiguration ?? {},
		metaData: {
			name,
			type: SavedViewTypes.Widget,
			id: '',
			isFavorite: false
		},
	};
}

export function transformExplorerCardToExplorer(card: SavedWidget): IExplorerView {
	return {
		layout: {
			layoutStyle: LAYOUT_OPTIONS['ONE'],
			cards: [
				{
					type: card.type,
					endpointQuery: card.dataConfiguration.endpointQuery,
					widgetConfiguration: card.widgetConfiguration,
				},
			],
		},
		filters: {
			timeline: card.dataConfiguration.filters.timeline,
			facets: {
				activeFacets: card.dataConfiguration.filters?.activeFacets || {},
				activeHierarchicalFacets: card.dataConfiguration.filters?.activeHierarchicalFacets || {},
				textFilter: ''
			}
		},
		selectedDefinitionName: card.dataConfiguration.selectedDefinition
	};
}
